import { AutocompleteStyle, TextFieldStyle } from "./style";
import { IAutocomplete } from "./type";

const MultipleAutocompleteComponent: React.FC<IAutocomplete> = ({ value, options, getOptionLabel, isOptionEqualToValue, defaultValue, onChange, label, name, touched, error }) => {
    return (
        <AutocompleteStyle
            multiple
            disableClearable
            value={value}
            options={options}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            defaultValue={defaultValue}
            onChange={onChange}
            renderInput={(params) => (
                <TextFieldStyle
                    {...params}
                    fullWidth
                    variant="standard"
                    label={label}
                    name={name}
                    error={Boolean(touched && error)}
                    helperText={touched && error} />
            )} />
    )
}

export default MultipleAutocompleteComponent;